 
 
 
 
 
 
/**
 * @ignore
 * Preconfigured svg icon
 */
define(['display/svgIcon'], function(SVGIcon) {
    'use strict';
    return function buildSimpleSVGIcon(iconName) {
        var options = {
            background: undefined,
            icon: {
                iconSize: [30, 30],
                iconAnchor: [0, 0],
                icon: iconName,
                noPlainSVG: false
            }
        };
        return new SVGIcon(options).createIcon();
    };
});



// WEBPACK FOOTER //
// ./services/popupContentGenerator/simpleSVGIcon.js